<app-base-list-wrapper [baseListComponent]="this">
    <ng-template #moreButtons let-table>
        @if (!filterByAttachedEntity()) {
            <div class="flex items-center gap-2">
                <app-employee-dropdown
                    #employeeDropdown
                    modelMode="IdOnly"
                    [selectedId]="selectedEmployeeId()"
                    (valueChange)="onEmployeeChange($event)"
                    [size]="'small'"
                    [placeholder]="'task.filter-by-assigned-employee' | translate"
                    [dataTestId]="'assigned-employee-filter'"
                ></app-employee-dropdown>
            </div>
        }
        <phx-checkbox
            [label]="'task.show-open-tasks-only' | translate"
            [ngModel]="showOpenTasksOnly()"
            (inlineChange)="onOpenTasksOnlyChange($event)"
            [dataTestId]="'open-tasks-only-checkbox'"
        ></phx-checkbox>
    </ng-template>
</app-base-list-wrapper>
